@if (vm$ | async; as vm) {
  <div class="wrapper--spacing-horizontal">
    <div class="identification__title">
      <h1 class="text--h1">{{ 'identification.identification-overview.title' | translate }}</h1>
      <button
        mat-flat-button
        color="accent"
        class="identification__add"
        (click)="openIdentificationAdd()"
      >
        <mat-icon>add</mat-icon>
        <span>{{ 'identification.add' | translate }}</span>
      </button>
    </div>
    <div class="spacing--margin-bottom">
      @if (filterConfig) {
        <agr-filter [config]="filterConfig" [formControl]="filterControl"></agr-filter>
      }
    </div>
    <div class="spacing--margin-bottom">
      @if (vm.aboutToExpire) {
        <div
          class="notification notification-info text--input-small"
          data-test="identification-overview__about-to-expire"
        >
          <mat-icon>info</mat-icon>
          {{ 'identification-overview.about-to-expire' | translate }}
        </div>
      }
      @if (vm.expired) {
        <div
          class="notification notification-warning text--input-small"
          data-test="identification-overview__expired"
        >
          <mat-icon>warning</mat-icon>
          {{ 'identification-overview.expired' | translate }}
        </div>
      }
    </div>
    <agr-table [config]="vm.tableConfig"></agr-table>
  </div>
  <ng-template #statusColumn let-row="row">
    @if (row.status === identificationStatusOptions.active) {
      <span class="flex--align-center column-gap">
        <mat-icon>check</mat-icon>
        <span>
          {{ 'identification.identification-overview.status-active' | translate }}
        </span>
      </span>
    }
    @if (row.status === identificationStatusOptions.inactive) {
      <span class="flex--align-center column-gap">
        <mat-icon>close</mat-icon>
        <span>
          {{ 'identification.identification-overview.status-inactive' | translate }}
        </span>
      </span>
    }
    @if (row.status === identificationStatusOptions.ended) {
      <span class="flex--align-center column-gap">
        <mat-icon>close</mat-icon>
        <span>
          {{ 'identification.identification-overview.status-ended' | translate }}
        </span>
      </span>
    }
  </ng-template>
}
